import { createCachedSelector, defaultKeySelector, bound } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { queryParamSelector } from '@cbridge-packages/routing';
import { SymbolGroupParam } from '../_helpers/symbolGroupSearchParam';

export const selectedSymbolGroupsSelector = createCachedSelector(
  [
    bound(queryParamSelector, SymbolGroupParam.name),
  ],
  (selectedSymbolGroups) => {
    return selectedSymbolGroups ? [selectedSymbolGroups] : [];
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
